export const PenIcon = ({ color = "#4E4E4E", size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${20} ${20}`}
    fill="none"
    {...props}
  >
    <path
      d="M13.2292 10.3958L10.1042 7.25L12.4167 4.95833L11.8125 4.35417L7.83333 8.33333C7.66667 8.5 7.47222 8.58333 7.25 8.58333C7.02778 8.58333 6.83333 8.5 6.66667 8.33333C6.5 8.16667 6.41667 7.96875 6.41667 7.73958C6.41667 7.51042 6.5 7.3125 6.66667 7.14583L10.625 3.1875C10.9583 2.85417 11.3507 2.6875 11.8021 2.6875C12.2535 2.6875 12.6458 2.85417 12.9792 3.1875L13.5833 3.79167L14.625 2.75C14.7917 2.58333 14.9896 2.5 15.2188 2.5C15.4479 2.5 15.6458 2.58333 15.8125 2.75L17.75 4.6875C17.9167 4.85417 18 5.05208 18 5.28125C18 5.51042 17.9167 5.70833 17.75 5.875L13.2292 10.3958ZM3.83333 17.5C3.59722 17.5 3.39931 17.4201 3.23958 17.2604C3.07986 17.1007 3 16.9028 3 16.6667V15.0625C3 14.8403 3.04167 14.6285 3.125 14.4271C3.20833 14.2257 3.32639 14.0486 3.47917 13.8958L8.91667 8.4375L12.0625 11.5625L6.60417 17.0208C6.45139 17.1736 6.27431 17.2917 6.07292 17.375C5.87153 17.4583 5.65972 17.5 5.4375 17.5H3.83333Z"
      fill={color}
    />
  </svg>
);
